import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {IonicVue} from "@ionic/vue";
import {IonicConfig} from "@ionic/core";
import {createPinia} from "pinia";
import {VueQueryPlugin} from "@tanstack/vue-query";
//import "@/plugins/ServiceWorker/registerServiceWorker";
import {maskito} from "@maskito/vue";
import {RecycleScroller} from 'vue-virtual-scroller';

/*----- Core CSS required for Ionic components to work properly -----*/
import "@ionic/vue/css/core.css";

/*----- Basic CSS for apps built with Ionic -----*/
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/*----- Additional Ionic CSS utils -----*/
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

/*----- default v-calendar css -----*/
import 'v-calendar/style.css';

/*----- Theme variables -----*/
import "@ionic/vue/css/palettes/dark.class.css";
import "./themes/light.scss";
import "./themes/dark.scss";


/*----- custom css -----*/
import "./themes/app.scss";

/*----- localization -----*/
import Translator from "@/plugins/Translator";
import {Config} from "@/models/settings/Config";
import MockApiService from "@/mock/MockApiService";

/*----- internationalization -----*/
const i18n = Translator.getInstance().getI18nInstance();

/*----- pinia store -----*/
const pinia = createPinia();

// set ionic options
const ionicConfig: IonicConfig = {
    innerHTMLTemplatesEnabled: true, // enable html output in toast, alert,
    hardwareBackButton: true, // enable hardware back button functionality
};

/*----- create vue app -----*/
const app = createApp(App)
    .use(IonicVue, ionicConfig)
    .use(router).use(pinia).use(VueQueryPlugin).use(i18n);

/*----- validation directive, add or remove css class -----*/
// used to display the error message underneath of an input
app.directive("validation-class-names", {
    updated(el: any, binding: any) {
        if (binding.value !== undefined) {
            el.classList.toggle("ion-valid", binding.value.valid);
            el.classList.toggle("ion-invalid", !binding.value.valid);
            el.classList.toggle("ion-touched", !binding.value.valid);
        }
    },
});

app.component('RecycleScroller', RecycleScroller);
/*----- input masking -----*/
app.directive("maskito", maskito);

/*----- init router and mount app -----*/
router.isReady().then(() => {
    app.mount("#app");
});

/*----- local mock api testing -----*/
if (Config.isLocalDevelopmentApi()) {
    const mockApiService = new MockApiService();
    mockApiService.startServer();
}

export default app;
